export const timer = (delay: number) =>
  new Promise(resolve => {
    setTimeout(resolve, delay);
  });
